import Header from '../components/header'
import Main from '../components/main'
import './index.css'

export default function Home() {
    return (

        <>
            <Header />
            <Main />
        </>

    )
}